import { render, staticRenderFns } from "./filters_dropdown.vue?vue&type=template&id=bbab3c3e&"
import script from "./filters_dropdown.vue?vue&type=script&lang=js&"
export * from "./filters_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports